import {
  trigger,
  transition,
  style,
  query,
  group,
  animateChild,
  animate,
  keyframes,
} from '@angular/animations';

export const slideInAnimation = trigger('routeAnimations', [
  // Login to Home Animation
  transition('LoginPage => HomePage', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ 
        transform: 'translateX(100%)',
        opacity: 0
      })
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            transform: 'translateX(-100%)',
            opacity: 0
          })
        )
      ], { optional: true }),
      query(':enter', [
        animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            transform: 'translateX(0%)',
            opacity: 1
          })
        )
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),

  // Home to Login Animation (reverse)
  transition('HomePage => LoginPage', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ 
        transform: 'translateX(-100%)',
        opacity: 0
      })
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            transform: 'translateX(100%)',
            opacity: 0
          })
        )
      ], { optional: true }),
      query(':enter', [
        animate('400ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            transform: 'translateX(0%)',
            opacity: 1
          })
        )
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ]),

  // General fade transition for other routes
  transition('* <=> *', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      })
    ], { optional: true }),
    query(':enter', [
      style({ 
        opacity: 0,
        transform: 'scale(0.95)'
      })
    ], { optional: true }),
    query(':leave', animateChild(), { optional: true }),
    group([
      query(':leave', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            opacity: 0,
            transform: 'scale(1.05)'
          })
        )
      ], { optional: true }),
      query(':enter', [
        animate('300ms cubic-bezier(0.4, 0, 0.2, 1)', 
          style({ 
            opacity: 1,
            transform: 'scale(1)'
          })
        )
      ], { optional: true })
    ]),
    query(':enter', animateChild(), { optional: true }),
  ])
]);

// Smooth loading animation for individual components
export const fadeInUp = trigger('fadeInUp', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateY(30px)'
    }),
    animate('600ms cubic-bezier(0.4, 0, 0.2, 1)', style({
      opacity: 1,
      transform: 'translateY(0)'
    }))
  ])
]);

// Slide animation for forms
export const slideInLeft = trigger('slideInLeft', [
  transition(':enter', [
    style({
      opacity: 0,
      transform: 'translateX(-50px)'
    }),
    animate('500ms cubic-bezier(0.4, 0, 0.2, 1)', style({
      opacity: 1,
      transform: 'translateX(0)'
    }))
  ])
]);
